// removed by extract-text-webpack-plugin
module.exports = {"component":"_2jXrietiXXP3Wyq0uApWXK","flexPrev":"_1OMWeFBEPxVnXE5ZcEn6GA","flexNext":"_3tgktMqpSX5G_TUUzUQxXh","flexFirst":"_3F8bQHOwRqQZMEu5naXcsP","carousel":"_3CFpgbbYP04Ab7dbmaqjS8","carouselItem":"_3WWsf3GTNR1l4nz8fvvcXD","btn":"_3bWfK4ReUq1Lj4g2Za7xa5","title":"_3410n0_-MsD21nKkt1XAKD","price":"_2xxYc-HqUsmf5GbnBqPc4r","content":"gqIRBzSLNWRlzXKmBoUYF","dotsClass":"_1Zdl_PR8JgwhmTIcpR3GzS","slick-active":"cQnlpUibpmufG8-nH8x8j"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarouselTextOfDetail/CarouselTextOfDetail.scss
 ** module id = 257
 ** module chunks = 0
 **/